import { auditReports } from '@mi-front/api-clients';
import { MrtTable } from '@mi-front/ui';
import { MRT_ColumnDef } from 'material-react-table';
import { useGipResultColumnsFactory } from './useGipResultColumnsFactory';

interface Props {
  schedules: auditReports.GipReportScheduleDto[];
}

export const GipReportUnprocessedSchedulesView = ({ schedules: unprocessedSchedules }: Props) => {
  const columns = useGipResultColumnsFactory();

  const tableColumns = [
    columns.materialStatus,
    columns.station,
    columns.date,
    columns.time,
    columns.advertiser,
    columns.campaign,
    columns.version,
    columns.customId,
    columns.contract,
    columns.order,
  ] as unknown as MRT_ColumnDef<auditReports.GipReportScheduleDto>[];

  return (
    <MrtTable<auditReports.GipReportScheduleDto>
      data={unprocessedSchedules}
      columns={tableColumns}
      muiTableBodyRowProps={({ row }) => {
        const { audioId } = row.original;
        const isMissing = !audioId;

        return {
          sx: {
            backgroundColor: isMissing ? 'rgba(255, 152, 0, 0.1) !important' : 'inherit',
            '&:hover': {
              backgroundColor: isMissing ? 'rgba(255, 152, 0, 0.2) !important' : 'inherit',
            },
          },
        };
      }}
    />
  );
};
